import { React, useEffect, useState } from 'react'
import axios from 'axios'
import {Table, Checkbox } from 'flowbite-react'
import LoadingSpinner from '../../components/LoadingSpinner';


const PermissionList = ({onClose,roleId}) => {
    const [Permissions, setPermissions] = useState([]);
    const [Error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);


    const handleChange = async (id,checked) => {

        setPermissions((prevPermissions) =>
            prevPermissions.map((permission) =>
                permission.id === id
            ? { ...permission, checked: !permission.checked } 
            : permission
            )
        );
        console.log(`id:${id} checked: ${!checked}`);
        setIsLoading(true);
        const response = await axios.post( 
            `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/permissionrole/${roleId}/findorcreate`,
            {
                permissionId: id
            },
            {
                withCredentials: true,
            }
        );
        setIsLoading(false);
        
    };

    useEffect(()=>{
        const getPermissionsByRole = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/permissionrole/${roleId}`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setPermissions(response.data.permissions);
            } catch (error) {
                setError(error.message);
            } finally{
                setIsLoading(false);
            }
        }
        getPermissionsByRole();
    },[]);

  return (
    <>
        {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
        <div className="overflow-x-auto">
        <Table hoverable>
            <Table.Head>
            <Table.HeadCell className="p-2"></Table.HeadCell>
            <Table.HeadCell>Permiso</Table.HeadCell>
            <Table.HeadCell>Descripción</Table.HeadCell>
            <Table.HeadCell>Slug</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
                {Permissions.map((permission) => (
                    <Table.Row key={permission.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                        <Table.Cell className="p-2">
                        <Checkbox 
                            key={permission.id}
                            name="checkPermission"
                            onChange={()=>handleChange(permission.id, permission.checked)} 
                            checked={permission.checked}
                            />
                        </Table.Cell>
                        <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                            {permission.name}
                        </Table.Cell>
                        <Table.Cell>{permission.description}</Table.Cell>
                        <Table.Cell>{permission.slug}</Table.Cell>
                    </Table.Row>
                ))}

            </Table.Body>
        </Table>
        </div>
    </>
  )
}

export default PermissionList
    